export enum TemplateType {
  NewParticipantsInvitation = 1,
  ExistingParticipantsInvitation = 2,
  UserAccountLocked = 3,
  RegistrationMoreInfoEmail = 4,
  RegistrationConfirmationEmail = 5,
  UnhandledErrorEmail = 6,
  GenericEmail = 7,
  NewDocumentNotification = 8,
  UpdateDocumentNotification = 9,
  NewQuestionNotification = 10,
  NewAnswerNotification = 11,
  NewsletterNotification = 12,
  ResetUserPasswordEmail = 13,
  FirstTimeVisitNotification = 14,
  UserRegistrationNotification = 15,
  SwimLane = 16,
  Claim = 17,
  Reminder = 18,
  Escalation = 19,
  Release = 20,
  DocumentExpirationNotification = 21,
  InvestigativeSitesExpiration = 22,
  ReviewFeedback = 23,
  RegPackEmail = 31,
  ReturnedBackToReviewer = 40,
  UserEmail = 44,
  DocumentQueryReminder = 45,
  QueryReviewFeedback = 57,
  QueryEmailPlaceholder = 58,
  AuditQueryReviewFeedback = 59,
  DocumentRejectionNotification = 60,
  CRAReconciliationReview = 61,
  ReconciliationReportToCRAManager = 63,
  GeneralQueryEmail = 71,
  ResponsiblePartyMissingDocumentsReminder = 72,
  RegulatoryPacketEmailReminder = 73,
  Rejection = 74,
  QMSQuerySystemTemplate = 82,
  SSUQueryEmailTemplate = 88,
}
